import { call, put, select, takeEvery } from "redux-saga/effects";
import { getIsBannersEnabledSelector, getIsBannersInitedSelector, makeSelectGetBannerByName } from "./bannersSelectors";
import { getRequest } from "../../app/request";
import { failurePut } from "../../app/failurePut";
import { bannersSlice } from "./bannersReducer";
import { IBannerDTO } from "./banners.t";
import { sendNotificationMessageAction } from "../Notifications/notificationsReducer";
import {
    NOTIFICATION_MESSAGE_BANNER_EVENTS,
    NOTIFICATIONS_MESSAGE_TYPES
} from "../Notifications/notificationsConstants";

function* initBannersSaga() {
    const isInited = yield select(getIsBannersInitedSelector);

    if (isInited) return;
    yield put(bannersSlice.actions.setBannersInitedAction(true));

    const isBannersEnabled = yield select(getIsBannersEnabledSelector);
    if (!isBannersEnabled) return;

    yield put(bannersSlice.actions.loadBannersListAction());
}

function* loadBannersListSaga() {
    try {
        const isBannersEnabled = yield select(getIsBannersEnabledSelector);
        if (!isBannersEnabled) {
            yield put(bannersSlice.actions.loadBannersListSuccess([]));
        }
        const data: IBannerDTO[] = yield call(getRequest, '/user/banners');
        yield put(bannersSlice.actions.loadBannersListSuccess(data));
    } catch (e) {
        yield call(failurePut, e, bannersSlice.actions.loadBannersListFailure);
    }
}

function* sendUpdateBannerParamsSaga({ payload }: { payload: { name: string } }) {
    const banner = yield select(makeSelectGetBannerByName(payload.name));
    yield put(
        sendNotificationMessageAction({
            type: NOTIFICATIONS_MESSAGE_TYPES.BANNER,
            params: {
                event: NOTIFICATION_MESSAGE_BANNER_EVENTS.UPDATE_PARAMS,
                payload: {
                    name: payload.name,
                    params: banner.params,
                },
            }
        }),
    );
}

export function* bannersSagas() {
    yield takeEvery(bannersSlice.actions.initBannersAction, initBannersSaga);
    yield takeEvery(bannersSlice.actions.loadBannersListAction, loadBannersListSaga);
    yield takeEvery(bannersSlice.actions.closeBannerAction, sendUpdateBannerParamsSaga);
}
